import head from "./head";
import locale from "./locale";

export default { head, locale };
